import React from 'react';
import { Grid, Tooltip } from '@mui/material';
import { CustomTextField, CustomSelect, CustomSwitch } from './FormElements';
import { useUser } from './UserContext';

interface CustomGridItemProps {
  type: 'text' | 'select' | 'switch';
  label: string;
  value: any;
  onChange: (event: any) => void;
  options?: any[];
  required?: boolean;
  checked?: boolean;
  xs?: number;
  multiline?: boolean;
  minRows?: number;
  sx?: any;
  fieldName?: string;
}

const CustomGridItem: React.FC<CustomGridItemProps> = ({ 
  type, 
  label, 
  value, 
  onChange, 
  options = [], 
  required = false, 
  checked, 
  xs = 6, 
  multiline = false, 
  minRows, 
  sx,
  fieldName
}) => {
  const { user } = useUser();
  
  const isDisabled = fieldName === 'status' && user?.role !== 'admin';
  const tooltipTitle = isDisabled ? "To change device status, please update the location instead" : "";

  const renderField = () => {
    if (type === 'text') {
      return (
        <CustomTextField
          label={label}
          value={value}
          onChange={onChange}
          required={required}
          multiline={multiline}
          minRows={minRows}
          sx={sx}
          disabled={isDisabled}
        />
      );
    }
    if (type === 'select') {
      return (
        <CustomSelect
          label={label}
          value={value}
          onChange={onChange}
          options={options}
          required={required}
          disabled={isDisabled}
        />
      );
    }
    if (type === 'switch') {
      return (
        <CustomSwitch
          label={label}
          checked={checked}
          onChange={onChange}
          disabled={isDisabled}
        />
      );
    }
  };

  return (
    <Grid item xs={xs}>
      <Tooltip title={tooltipTitle} arrow placement="top">
        <div style={{ width: '100%' }}>
          {renderField()}
        </div>
      </Tooltip>
    </Grid>
  );
};

export default CustomGridItem;
